<template>
    <button class="button__config button__settings invert" @click="toggleOptions">
      <span class="label">Voorkeuren</span>
        <svg class="icon icon-settings">
          <use xlink:href="../assets/sprite.svg#settings-icon"></use>
        </svg>
    </button>

    <transition name="slide">
    <div v-if="optionsVisible" class="config">
        <div class="config__settings-refresh">
          <div class="wrapper">
            <button class="button__login" @click="login">Login</button>
          </div>
          <div class="wrapper refresh">
            <label>Auto refresh</label>
            <input class="checkbox__config" type="checkbox" v-model="autoRefresh" @change="updateAutoRefresh($event)">
            <button class="button__config" @click="loadSchedule">
              <span class="label">Refresh</span>
              <svg class="icon icon-refresh">
                <use xlink:href="../assets/sprite.svg#refresh-icon"></use>
              </svg>
            </button>
          </div>
        </div>
      <button class="button__reset button__close" @click="toggleOptions">
          <svg class="icon icon-close">
            <use xlink:href="../assets/sprite.svg#cross-icon"></use>
          </svg>
        <span class="label">Sluiten</span>
      </button>
      <h3>Weergave</h3>
      <div class="config__settings">
        <h5>Titel</h5>
        <div class="config__settings-title">
          <input type="text" v-model="title">
          <button class="button__config" @click="changeTitle">
            <span class="label">Opslaan</span>
            <svg class="icon icon-save">
              <use xlink:href="../assets/sprite.svg#save-icon"></use>
            </svg>
          </button>
        </div>
        <h5>Werkdagen</h5>
        <div class="config__settings-workDays">
          <input type="number" min="1" max="10" v-model="workDays">
          <button class="button__config" @click="changeWorkDays">
            <span class="label">Opslaan</span>
            <svg class="icon icon-save">
              <use xlink:href="../assets/sprite.svg#save-icon"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </transition>
  <transition name="fade">
    <div v-if="optionsVisible" class="config__overlay" @click="toggleOptions"></div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      title: this.$store.getters.title,
      workDays: this.$store.getters.workDays,
      autoRefresh: this.$store.getters.autoRefresh,
      autoRefreshLoop: null,
      optionsVisible: false
    }
  },
  methods: {
    toggleOptions() {
      this.optionsVisible = !this.optionsVisible
    },
    login() {
      this.$store.dispatch('login', {
        scopes: ["Calendars.Read", "Calendars.Read.Shared", "GroupMember.Read.All", "Group.Read.All", "User.Read.All"]
      })
    },
    loadSchedule() {
      this.$store.dispatch('calculateDateWindow')
      this.$store.dispatch('loadSchedule')
    },
    changeTitle() {
      this.$store.commit('title', this.title)
    },
    changeWorkDays() {
      this.$store.commit('workDays', this.workDays)
      this.$store.dispatch('calculateDateWindow')
      this.$store.dispatch('loadSchedule')
    },
    updateAutoRefresh() {
      this.$store.commit('autoRefresh', this.autoRefresh)
    },
    autoRefreshAction() {
      this.autoRefreshLoop = setInterval(() => {
        if (this.$store.getters.autoRefresh) {
          this.$store.dispatch('calculateDateWindow')
          this.$store.dispatch('loadSchedule')
        }
      }, 3600000)
    }
  },
  beforeUnmount () {
    clearInterval(this.autoRefreshLoop)
  },
  mounted () {
    this.autoRefreshAction()
  }
}
</script>

<style scoped>
  .config {
    background: var(--gradient-background-2);
    box-shadow: var(--box-shadow-main-large);
    height: 100vh;
    padding: var(--gutter-sm) var(--gutter-xl) var(--gutter-lg) var(--gutter-lg);
    position: fixed;
    overflow-y: auto;
    right: 0;
    text-align: left;
    top: 0;
    transition: transform 330ms ease-out;
    z-index: 40;
  }
  .button__login {
  }
  .button__close {
    cursor: pointer;
    position: fixed;
    right: var(--gutter-md);
    top: var(--gutter-md);
    z-index: 10;
  }
  .button__close .label {
    display: none;
  }
  .button__close .icon-close {
    height: var(--gutter-md);
    width: var(--gutter-md);
  }
  .button__config {
    align-items: center;
    display: flex;
    justify-content: center;
    padding: var(--gutter-xs) 0;
    width: 4.6rem;
  }

  .button__config .label {
    display: none;
  }
  .button__config .icon {
    fill: var(--color-brand-2nd);
    height: 2rem;
    width: 2rem;
  }
  .button__config:hover .icon {
    fill: #fff;
  }
  .button__config.invert .icon {
    fill: #fff;
  }
  .button__config.invert:hover .icon {
    fill: var(--color-brand-2nd);
  }
  .button__settings {
    position: absolute;
    right: 0;
    top: 0;
  }
  .config__overlay {
    background: var(--gradient-overlay-2);
    content: '';
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 35;
  }
  .config__settings-title,
  .config__settings-workDays,
  .config__settings-refresh {
    align-items: flex-end;
    display: flex;
    justify-content: space-between;
    margin: 0 0 var(--gutter-xs);
  }
  .config__settings-title input,
  .config__settings-workDays input {
    margin: 0 var(--gutter-xs) 0 0;
  }
  .config__settings-refresh {
    margin-bottom: var(--gutter-md);
  }
  .wrapper.refresh {
    align-items: center;
    justify-content: flex-end;
    display: flex;
    flex-wrap: wrap;
    margin-left: auto;
    padding-left: var(--gutter-sm);
  }
  .wrapper.refresh label {
    margin-right: var(--gutter-sm);
    text-align: right;
  }
  .wrapper.refresh .checkbox__config {
    margin-right: var(--gutter-sm);
  }

</style>
